import type { PolyLine2 } from "geom/polyLine2Types";
import type { Vec2 } from "geom/vec2";
import type { WallInterval, WallIntervalEntityType } from "./wallTraverseTypes";

interface GetPlanOutlineVertexOptions {
  readonly planOutline: PolyLine2;
  readonly frontEdge: boolean;
  readonly clockwise: boolean;
}

export function getFirstPlanOutlineVertexAlongTraversal({
  planOutline,
  frontEdge,
  clockwise,
}: GetPlanOutlineVertexOptions): Vec2 {
  if (frontEdge) {
    return !clockwise ? [planOutline[2], planOutline[3]] : [planOutline[0], planOutline[1]];
  }
  return !clockwise ? [planOutline[6], planOutline[7]] : [planOutline[4], planOutline[5]];
}

export function getLastPlanOutlineVertexAlongTraversal({
  planOutline,
  frontEdge,
  clockwise,
}: GetPlanOutlineVertexOptions): Vec2 {
  if (frontEdge) {
    return clockwise ? [planOutline[2], planOutline[3]] : [planOutline[0], planOutline[1]];
  }
  return clockwise ? [planOutline[6], planOutline[7]] : [planOutline[4], planOutline[5]];
}

export function makeWallInterval(
  startParam: number,
  endParam: number,
  type?: WallIntervalEntityType,
  entityId?: string,
  front?: boolean,
): WallInterval {
  return {
    right: { param: startParam, extentIds: entityId ? { [entityId]: true } : {} },
    left: { param: endParam, extentIds: entityId ? { [entityId]: true } : {} },
    entities: type ? { [type]: true } : {},
    frontEntityIds: entityId && front ? { [entityId]: true } : {},
    backEntityIds: entityId && !front ? { [entityId]: true } : {},
  };
}
